import React from 'react';
import HeroSection from '../components/common/HeroSection';
import SectionTitle from '../components/common/SectionTitle';
import { Link } from 'react-router-dom';

const Solutions = () => {
  const solutions = [
    {
      title: "Enterprise Solutions",
      description: "Comprehensive enterprise solutions tailored to meet complex business requirements and enhance operational efficiency.",
      features: [
        "ERP System Integration",
        "Business Process Automation",
        "Enterprise Application Development",
        "Digital Transformation Solutions"
      ],
      image: "/assets/images/solutions/enterprise.jpg"
    },
    {
      title: "Industry-Specific Solutions",
      description: "Specialized solutions designed to address the unique challenges and requirements of specific industries.",
      features: [
        "Healthcare Management Systems",
        "Financial Technology Solutions",
        "Retail and E-commerce Platforms",
        "Manufacturing and Supply Chain Systems"
      ],
      image: "/assets/images/solutions/industry.jpg"
    },
    {
      title: "Cloud Solutions",
      description: "Scalable cloud-based solutions to enhance flexibility, accessibility, and cost-efficiency.",
      features: [
        "Cloud Migration Services",
        "Cloud-Native Application Development",
        "Hybrid Cloud Solutions",
        "Cloud Infrastructure Management"
      ],
      image: "/assets/images/solutions/cloud.jpg"
    },
    {
      title: "Mobility Solutions",
      description: "Mobile-first solutions to keep your business connected and accessible from anywhere.",
      features: [
        "Cross-Platform Mobile Applications",
        "Enterprise Mobility Management",
        "Mobile-Responsive Web Applications",
        "IoT-Enabled Mobile Solutions"
      ],
      image: "/assets/images/solutions/mobility.jpg"
    }
  ];

  return (
    <div className="solutions-page">
      <HeroSection 
        title="Solutions"
        breadcrumb={[{ name: 'Solutions' }]}
        background="/assets/images/solutions-bg.jpg"
      />
      
      <section className="py-16">
        <div className="container mx-auto px-4">
          <SectionTitle 
            subtitle="Our Solutions"
            title="Innovative Technology Solutions for Business Growth"
            className="mb-16"
          />
          
          <div className="space-y-20">
            {solutions.map((solution, index) => (
              <div 
                key={index} 
                className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-8 lg:gap-16`}
              >
                <div className="lg:w-1/2">
                  <img 
                    src={solution.image || "/assets/images/solutions/placeholder.jpg"} 
                    alt={solution.title} 
                    className="rounded-lg shadow-lg w-full object-cover h-64 md:h-80"
                  />
                </div>
                
                <div className="lg:w-1/2">
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">{solution.title}</h3>
                  <p className="text-gray-600 mb-6">{solution.description}</p>
                  
                  <h4 className="text-lg font-semibold text-gray-800 mb-3">Key Features:</h4>
                  <ul className="space-y-2">
                    {solution.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-start">
                        <div className="mr-3 mt-1 text-blue-600">
                          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                          </svg>
                        </div>
                        <span className="text-gray-600">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  
                  <button className="mt-6 inline-flex items-center text-blue-600 font-medium hover:text-blue-800 transition-colors">
                    Learn More 
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      className="h-5 w-5 ml-1" 
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M14 5l7 7m0 0l-7 7m7-7H3" 
                      />
                    </svg>
                  </button>
                </div>
              </div>
            ))}
          </div>
          
          <div className="mt-20 bg-blue-50 rounded-lg p-8 md:p-12">
            <div className="max-w-3xl mx-auto text-center">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Need a Custom Solution?</h3>
              <p className="text-gray-600 mb-8">
                We understand that every business has unique requirements. Our team can develop
                custom solutions tailored specifically to address your business needs.
              </p>
              <Link 
                to="/contact-us" 
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded inline-block transition-colors"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Solutions;